export const heightOfSidePanelContent = window.innerHeight - 76; // height of header (36px) with 20px padding top and bottom
